import React from "react";
import {useState} from "react";
import "./StatsCard.css"; // Import the CSS file for styling
import verticalLine from "../../assets/Icons/verticalLine.svg";


const StatsCard = ({ data ,isRevenue}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (   
    <div className="stats-card">
      {data.map((section, index) => (
        <React.Fragment key={index}>
          <div className="stats-section">
            <div className="icon-wrapper">
              <img src={section.icon} alt={section.title} className="icon" />
            </div>
            <div className="stats-content">
              {showTooltip ? section.infocard:""}
              <p className="title">{section.title}<span className="info"
              onMouseEnter={() => setShowTooltip(true)}
              onMouseLeave={() => setShowTooltip(false)}
              ><img src={section.info}/></span></p>
              <p className="value">{section.amount}{section.value} </p>
              {section.total}
              {section.percentage}
            </div>
          </div>
          {/* Add the vertical line between sections, except the last one */}
          {index < data.length - 1 && (
            <div className="separator">
              <img
                src={verticalLine}
                alt="separator"
                className="separator-line"
              />
            </div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default StatsCard;
